import { Component, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { HttpCommonService, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { CheckboxLlist } from "./checkbox-list.model";
import { SelectorService } from "../base/selector.service";

@Component({
  //moduleId: module.id,
  selector: "ssg-checkbox-list",
  templateUrl: "./checkbox-list.component.html",
  styleUrls: ["./checkbox-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxListComponent extends BaseControlComponent<number[]> {
  ids: number[] = [];
  _list: CheckboxLlist[] = [];
  selist() {
    if (!this._list || this._list.length === 0) {
      if (this.items && this.items.length > 0) {
        this.items.forEach((x) => {
          let item: CheckboxLlist = <CheckboxLlist>{};
          item.Id = x[this.valueFieldName];
          item.Title = x[this.textFieldName];
          item.Selected = this.isSelect(item.Id);
          this._list.push(item);
          setTimeout(() => this.cd.markForCheck(), 50);
        });
      } else if (this.items["Data"] && this.items["Data"].length > 0) {
        this.items["Data"].forEach((element) => {
          let item: CheckboxLlist = <CheckboxLlist>{};
          item.Id = element[this.valueFieldName];
          item.Title = element[this.textFieldName];
          item.Selected = this.isSelect(item.Id);
          this._list.push(item);
          setTimeout(() => this.cd.markForCheck(), 50);
        });
      }
    }
  }
  _items: any[] = [];
  get items(): any[] {
    return this._items;
  }
  set items(value: any[]) {
    this._items = value;
    this.selist();
  }
  @Input()
  get checkboxLlist(): CheckboxLlist[] {
    return this._list;
  }
  set checkboxLlist(value: CheckboxLlist[]) {
    this._list = value;
  }
  @Input()
  get dataList(): any[] {
    return this.items;
  }
  set dataList(value: any[]) {
    this._items = value;
    this.selist();
  }
  @Input() userClass1: string = "";
  @Input() userClass2: string = "";
  constructor(
    private _httpCommonService: HttpCommonService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private lookupservice: LookupService
  ) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    if (!this.items) this.items = [];
    super.ngOnInit();

    if (this.f[this.name].value) {
      this.ids = this.f[this.name].value;
    }

    if (this.name && this.f && this.f[this.name]) {
      this.f[this.name]?.valueChanges?.subscribe((x) => {
        if (x && x.length > 0) this.ids = x;
      });
    }

    if (this.apiName) {
      if (!this.systemName && !this.category) {
        this._httpCommonService
          .getList(this.apiName)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (data) => {
              this._items = data as [];
              this.selist();
            },
            error: (error) => {
              console.error(error);
            },
          });
      } else {
        this.lookupservice
          .getLookupbyCategory(this.systemName, this.category)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((data) => {
            this._items = data as [];
            this.selist();
          });
      }
    }
  }

  isSelect(id: number) {
    return this.ids.some((x) => x === id);
  }
  onChange(event: any) {
    if (typeof event.Id == "number") {
      if (!event.Selected && this.ids.some((x) => x === event.Id)) this.ids = this.ids.filter((x) => x !== event.Id);
      else if (!this.ids.some((x) => x === event.Id)) this.ids.push(event.Id);
      this.f[this.name].setValue(this.ids);
      super.onChange(event);
    }
  }
}
